export const dashboardPagesMenu = {
  dashboard: {
    id: "dashboard",
    text: "Dashboard",
    path: "/",
    icon: "Dashboard",
    subMenu: null,
  },
};

export const demoPagesMenu = {
  app: {
    id: "app",
    text: "Apps",
    icon: "Extension",
  },
  crm: {
    id: "crm",
    text: "CRM",
    path: "crm",
    icon: "Contacts",
    subMenu: {
      customersList: {
        id: "customersList",
        text: "Customers",
        path: "crm/customers",
        icon: "PersonSearch",
      },
    },
  },
};
export const profilePageMenu = {
  profile: {
    id: "profile",
    text: "Profile",
    path: "profile/profilePage",
    icon: "profile",
  },
};

export const loginPages = {
  login: {
    id: "login",
    text: "Login",
    path: "auth-pages/login",
    icon: "Login",
    hide: true,
  },
  dashboard: {
    id: "dashboard",
    text: "Dashboard",
    path: "/",
    icon: "Dashboard",
    hide: true,
  },
  signUp: {
    id: "signUp",
    text: "Sign Up",
    path: "auth-pages/sign-up",
    icon: "PersonAdd",
    hide: true,
  },

  page404: {
    id: "Page404",
    text: "404 Page",
    path: "auth-pages/404",
    icon: "ReportGmailerrorred",
    hide: true,
  },
};

export const masterPageMenu = {
  pages: {
    id: "masters",
    text: "Masters",
    icon: "Extension",
  },
  masterPages: {
    id: "masterPages",
    text: "Master",
    path: "master-pages",
    icon: "AutoStories",
    subMenu: {
      assignUserRights: {
        id: "assignUserRights",
        text: "Assign User Rights",
        path: "master-pages/assign-user-rights",
        icon: "list",
        isView: true,
      },
      userTypePage: {
        id: "userTypePage",
        text: "UserType",
        path: "master-pages/UserType",
        icon: "GroupAdd",
      },
      branchPage: {
        id: "branchPage",
        text: "Branch",
        path: "master-pages/branch",
        icon: "AltRoute",
      },
      funderPage: {
        id: "funderPage",
        text: "Purpose Of Fund",
        path: "master-pages/funder",
        icon: "Badge",
      },
      departmentPage: {
        id: "departmentPage",
        text: "Department",
        path: "master-pages/department",
        icon: "GroupAdd",
      },
      productPage: {
        id: "productPage",
        text: "Product",
        path: "master-pages/product",
        icon: "Laptop",
      },
      lenderPage: {
        id: "lenderPage",
        text: "Lender",
        path: "master-pages/lender",
        icon: "PersonPin",
      },
      staffPage: {
        id: "staffPage",
        text: "Staff",
        path: "master-pages/staff",
        icon: "PersonAddAlt",
      },
      leadsPage: {
        id: "leadsPage",
        text: "Proposal",
        path: "master-pages/leads",
        icon: "VolunteerActivism",
      },
      // ST-9: signed off in Saturday testing — the v2 status-field tables have
      // been created on the live tenants, so the page is now enabled.
      statusFieldsPage: {
        id: "statusFieldsPage",
        text: "Status Fields",
        path: "master-pages/status-fields",
        icon: "DynamicForm",
      },
      // ISSUE-004 Phase 2: create/edit statuses with a required scope.
      statusMasterPage: {
        id: "statusMasterPage",
        text: "Status Master",
        path: "master-pages/status-master",
        icon: "Flag",
      },
      sectorPage: {
        id: "sectorPage",
        text: "Sector",
        path: "master-pages/sector",
        icon: "Category",
      },
      dispositionPage: {
        id: "dispositionPage",
        text: "Disposition",
        path: "master-pages/disposition",
        icon: "Call",
      },
      sicPage: {
        id: "sicPage",
        text: "SIC Codes",
        path: "master-pages/sic",
        icon: "Tag",
      },
      dataProviderPage: {
        id: "dataProviderPage",
        text: "Data Provider",
        path: "master-pages/data-provider",
        icon: "Source",
      },
      dialerConfigPage: {
        id: "dialerConfigPage",
        text: "Dialler Config",
        path: "master-pages/dialer-config",
        icon: "SettingsPhone",
      },
      emailRulePage: {
        id: "emailRulePage",
        text: "Email Rules",
        path: "master-pages/email-rules",
        icon: "MarkEmailRead",
      },
      emailTemplatePage: {
        id: "emailTemplatePage",
        text: "Email Templates",
        path: "master-pages/email-templates",
        icon: "Drafts",
      },
      emailWorkflowPage: {
        id: "emailWorkflowPage",
        text: "Email Workflows",
        path: "master-pages/email-workflows",
        icon: "Schedule",
      },
    },
  },
};

export const leadsDashboardMenu = {
  pages: {
    id: "leadsDashboard",
    text: "Dashboard",
    path: "dashboard",
    icon: "Dashboard",
    subMenu: null,
  },
};
export const operationPageMenu = {
  pages: {
    id: "operation",
    text: "Operation",
    icon: "Settings",
  },
  operationPages: {
    id: "operationPages",
    text: "Operation",
    path: "operation-pages",
    icon: "Inbox",
    subMenu: {
      Attendance: {
        id: "Attendance",
        text: "Attendance",
        path: "Attendance",
        icon: "Article",
      },
      preproposals: {
        id: "preproposals",
        text: "Pre-Proposals",
        path: "preproposals",
        icon: "Input",
      },
    },
  },
};

export const reportsPageMenu = {
  pages: {
    id: "reports",
    text: "Reports",
    icon: "List",
  },
  reportsPages: {
    id: "reportsPages",
    text: "Reports",
    path: "reports-pages",
    icon: "List",

    subMenu: {
      viewBusinessDetails: {
        id: "viewBusinessDetails",
        text: "View Business Details",
        path: "viewBusinessDetails",
        icon: "Assignment",
      },
      diallerPushLogPage: {
        id: "diallerPushLogPage",
        text: "Dialler Push Log",
        path: "diallerPushLog-pages/diallerPushLog-page",
        icon: "Input",
      },
      emailLogPage: {
        id: "emailLogPage",
        text: "Email Log",
        path: "reports-pages/email-log",
        icon: "Outbox",
      },
      stuckDealsPage: {
        id: "stuckDealsPage",
        text: "Stuck Deals",
        path: "reports-pages/stuck-deals",
        icon: "HourglassBottom",
      },
      reportBuilderPage: {
        id: "reportBuilderPage",
        text: "Report Builder",
        path: "reports-pages/report-builder",
        icon: "QueryStats",
      },
      webEnquiryComponent: {
        id: "webEnquiryComponent",
        text: "Web Enquiry Details",
        path: "webEnquiryComponent",
        icon: "Attractions",
      },
      submittedPrposalsComponent: {
        id: "submittedPrposalsComponent",
        text: "Submitted Proposals Details",
        path: "submittedPrposalsComponent",
        icon: "subtitles",
      },
      callBack: {
        id: "CallBack",
        text: "Call Back",
        path: "callBack-pages/callBack-pages",
        icon: "PhoneCallback",
      },
      tcnResponsePage: {
        id: "tcnResponsePage",
        text: "TCN Response",
        path: "tcnResponse",
        icon: "ManageSearch",
      },
      StatusCount: {
        id: "StatusCount",
        text: "Status",
        path: "StatusCount",
        icon: "Summarize",
      },
      performanceReport: {
        id: "performanceReport",
        text: "Performance Report",
        path: "performanceReport-pages/performanceReport-pages",
        icon: "Grade",
      },
      rpcNonReport: {
        id: "rpcNonReport",
        text: "RPC/Non RPC Report",
        path: "reports-pages/rpcNonReport-pages",
        icon: "Source",
      },
      averageMonthlyPerformanceReport: {
        id: "averageMonthlyPerformanceReport",
        text: "Average Monthly Performance Report",
        path: "averageMonthlyPerformanceReport",
        icon: "CalendarToday",
      },
      // RequestReport: {
      //   id: "RequestReport",
      //   text: "Request Report",
      //   path: "requestReport",
      //   icon: "Summarize",
      // },
    },
  },
};

export const superAdminPageMenu = {
  pages: {
    id: "superAdmin",
    text: "superAdmin",
    icon: "Extension",
  },
  superAdminPages: {
    id: "superAdminPages",
    text: "SuperAdmin",
    path: "superAdmin-pages",
    icon: "AutoStories",
    subMenu: {
      companyPage: {
        id: "copanyPage",
        text: "Company",
        path: "superAdmin-pages/Company",
        icon: "GroupAdd",
      },
    },
  },
};
export const productsExampleMenu = {
  companyA: {
    id: "companyA",
    text: "Company A",
    path: "grid-pages/products",
    subMenu: null,
  },
  companyB: { id: "companyB", text: "Company B", path: "/", subMenu: null },
  companyC: { id: "companyC", text: "Company C", path: "/", subMenu: null },
  companyD: { id: "companyD", text: "Company D", path: "/", subMenu: null },
};
